import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

// Types the dispatch function to be aware of redux-thunk
// Allows us to do things like `const result = await dispatch(someAction())` and the result
// be properly typed
// If we upgrade our version of redux-thunk, this will be done automatically due to
// https://github.com/reduxjs/redux-thunk/pull/247
export const useThunkDispatch = () => useDispatch<ThunkDispatch<any, any, AnyAction>>();
